import React, { useState } from "react";
import { useGetUsersQuery } from "../../../redux/service/modules/admin";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import Layout from "../../../components/layout/Layout";
import UserDetailDialog from "./UserDetailDialog";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";

const UserDetails = () => {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchtext] = useState("");

    // Debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleSearch = debounce((value) => {
        setSearchtext(value);
    }, 500);
    return (
        <Layout>
            <CustomAdminLayout
                title={"User Details"}
                createButtonText={"Add New User"}
                createOnClick={() => {
                    setOpen(true);
                }}
                showSearchInput
                showCreateButton={true}
                onSearch={handleSearch}
                searchPlaceholder={"Search Users"}
            >
                <PaginatedDataTable
                    queryHook={useGetUsersQuery}
                    title="User Management"
                    paginationEnabled={true}
                    showEditColumn={true}
                    showCheckboxColumn={true}
                    appliedFilters={{ search: searchText }}
                    dialogType={"user"}
                />
                <UserDetailDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    isEdit={false}
                    title={"Add New User"}
                    ctaText={"ADD USER"}
                />
            </CustomAdminLayout>
        </Layout>
    );
};

export default UserDetails;
